import React, { FC, useState } from 'react';
import { View, ActivityIndicator } from 'react-native';
import SettingsItem from '../../component/SettingsItem/SettingsItem';
import { useColors } from '../../hooks/useColors';
import {
  FilterOption,
  SummaryLabels,
  summariseSelection,
} from '../../utils/docketFilter';
import SettingsScreenStyles from './Settings.styles';

interface DocketFilterRowProps {
  title: string;
  testID: string;
  optionTestIDPrefix: string;
  options: FilterOption[];
  selectedIds: string[];
  labels: SummaryLabels;
  loading?: boolean;
  onToggle: (id: string) => void;
}

const DocketFilterRow: FC<DocketFilterRowProps> = ({
  title,
  testID,
  optionTestIDPrefix,
  options,
  selectedIds,
  labels,
  loading,
  onToggle,
}) => {
  const styles = SettingsScreenStyles();
  const { colors } = useColors();
  const [open, setOpen] = useState(false);

  return (
    <>
      <SettingsItem
        type="parent"
        testID={testID}
        loading={loading}
        title={title}
        checked={open}
        subtitle={summariseSelection(options, selectedIds, labels)}
        onChange={() => setOpen(!open)}
      />
      {open ? (
        <View style={styles.subSection}>
          {!options.length && loading ? (
            <ActivityIndicator
              testID={`${testID}-loading`}
              color={colors.text}
            />
          ) : null}
          {options.map(option => (
            <SettingsItem
              key={option.id}
              type="select"
              testID={`${optionTestIDPrefix}-${option.id}`}
              loading={loading}
              title={option.name}
              checked={selectedIds.includes(option.id)}
              onChange={() => onToggle(option.id)}
            />
          ))}
        </View>
      ) : null}
    </>
  );
};

export default DocketFilterRow;
